import * as React from "react";
import {useRef, useState} from "react";
import {Trans, useTranslation} from "react-i18next";
import {useCustomerContext} from "../../../customer/CustomerContextProvider/CustomerContextProvider";
import {Button, ButtonStyles, ButtonType} from "../../../lib/form/Button/Button";
import ForgotPasswordModal from "../../../lib/ModalWindow/ForgotPasswordModal";
import MagicLinkModal from "../../../lib/ModalWindow/MagicLinkModal";
import Spinner from "../../../utils/loader/Spinner";
import {CheckoutError, LoginMode} from "../../Checkout";
import {ICredentials} from "@connox/typescript-library/types/customer/requestHandlers/CustomerRequestHandler";

const KnownCustomer: React.FC = () => {
  const {customer} = useCustomerContext();
  const {t} = useTranslation("checkout");
  const [{forgotVisible, magicVisible}, setModals] = useState<{
    forgotVisible: boolean;
    magicVisible: boolean;
  }>({forgotVisible: false, magicVisible: false});
  const buttonText = t("Einloggen");
  const emailInputRef = useRef<HTMLInputElement>(null);
  const passwordInputRef = useRef<HTMLInputElement>(null);
  const [{buttonState, errors}, setState] = React.useState<{buttonState: string | JSX.Element; errors: string[]}>({
    buttonState: buttonText,
    errors: [],
  });

  const email = customer.email || undefined;
  const login = async (evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.preventDefault();

    setState({buttonState: <Spinner />, errors: []});
    const credentials: ICredentials = {
      password: `${passwordInputRef.current?.value || ""}`,
      username: `${emailInputRef.current?.value || ""}`,
    };
    const loginErrors: string[] = [];
    if (!credentials.username) {
      loginErrors.push(t("Sie haben keine E-Mail-Adresse oder Kundennummer angegeben"));
    }
    if (!credentials.password) {
      loginErrors.push(t("Sie haben kein Passwort angegeben"));
    }
    if (loginErrors.length) {
      setState({buttonState: buttonText, errors: loginErrors});

      return;
    }

    const success = await customer.logIn(credentials);
    if (!success) {
      if (passwordInputRef.current){
        passwordInputRef.current.value = "";
      }
      setState({buttonState: buttonText, errors: [t("E-Mail oder Passwort falsch")]});
    }
  };

  return (
    <div className="KnownCustomer">
      <h1>{t("Bitte melden Sie sich an")}</h1>
      <CheckoutError>{errors}</CheckoutError>
      <form method="post">
        <input
          type="text"
          ref={emailInputRef}
          name="Email"
          id="LoginEmail"
          placeholder={t("Ihre E-Mail oder Kundennummer")}
          defaultValue={email}
        />
        <input type="password" name="Password" id="Password" ref={passwordInputRef} placeholder={t("Ihr Passwort")} />
        <Button
          btnIdentifier={LoginMode.KNOWNCUSTOMER}
          action={login}
          type={typeof buttonState === "string" ? ButtonType.default : ButtonType.disabled}
          styles={[ButtonStyles.wide]}
        >
          {buttonText}
        </Button>
        {/* Region: Modals */}
        <ForgotPasswordModal
          isVisible={forgotVisible}
          closeFunction={() => setModals({forgotVisible: false, magicVisible})}
        />
        <MagicLinkModal
          isVisible={magicVisible}
          closeFunction={() => setModals({forgotVisible, magicVisible: false})}
        />
        {/* endregion: Modals */}
        <p>
          <Trans i18nKey="Passwort vergessen?" ns="checkout">
            <span>Passwort vergessen?</span>
            <br />
            <span>
              <a
                href="#"
                onClick={(evt: React.MouseEvent<HTMLAnchorElement>) => {
                  evt.preventDefault();
                  setModals({forgotVisible: true, magicVisible});
                }}
              >
                Passwort zurücksetzen
              </a>
              oder
              <a
                href="#"
                onClick={(evt: React.MouseEvent<HTMLAnchorElement>) => {
                  evt.preventDefault();
                  setModals({forgotVisible, magicVisible: true});
                }}
              >
                ohne Passwort weiter
              </a>
            </span>
          </Trans>
        </p>
      </form>
    </div>
  );
};

export default KnownCustomer;
